import React, { useState } from 'react';
import axios from 'axios';

export default function CrossReviewPanel({ projectName, currentFile, currentCode }) {
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);

  const runReview = async () => {
    if (!currentCode) {
      alert('请先打开一个文件');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post('/api/review/cross', {
        projectName,
        filePath: currentFile,
        code: currentCode,
        language: guessLanguage(currentFile),
        models: ['openai/gpt-4', 'claude/opus'],
        dimensions: ['security', 'correctness', 'maintainability', 'performance']
      });

      setReport(res.data.report || res.data);
    } catch (err) {
      console.error('双模型评审失败:', err);
      setReport({
        error: true,
        message: '双模型评审接口暂未接通或执行失败',
        detail: err.response?.data?.error || err.message
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 text-sm">
      <h3 className="font-bold mb-3">双模型交叉评审</h3>

      <div className="bg-gray-900 rounded p-3 mb-3 text-xs text-gray-300">
        <div>当前项目：{projectName}</div>
        <div className="truncate">当前文件：{currentFile || '未选择文件'}</div>
        <div className="mt-2 text-orange-300">定位：双模型不是最高法官，只在五维宪法框架内执行评审。</div>
      </div>

      <button
        onClick={runReview}
        disabled={loading}
        className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-60 py-2 rounded mb-4"
      >
        {loading ? '评审中...' : '启动双模型评审'}
      </button>

      {!report && (
        <div className="text-gray-400 text-xs leading-6">
          <p>评审输出将包含：</p>
          <p>1. 模型A意见</p>
          <p>2. 模型B意见</p>
          <p>3. 共同问题</p>
          <p>4. 分歧问题</p>
          <p>5. 可返回修改的补丁建议</p>
        </div>
      )}

      {report && (
        <pre className="bg-black text-green-400 p-3 rounded h-96 overflow-auto text-xs whitespace-pre-wrap">
          {JSON.stringify(report, null, 2)}
        </pre>
      )}
    </div>
  );
}

function guessLanguage(filePath) {
  const safePath = String(filePath || '');
  const ext = safePath.split('.').pop()?.toLowerCase();

  const map = {
    js: 'javascript',
    jsx: 'javascript',
    ts: 'typescript',
    tsx: 'typescript',
    py: 'python',
    json: 'json',
    html: 'html',
    css: 'css',
    md: 'markdown',
    yml: 'yaml',
    yaml: 'yaml',
    sh: 'shell'
  };

  return map[ext] || 'plaintext';
}
